import React from "react";

const InteractiveText = ({ variant, children, className, onClick }) => {
  return (
    <>
      {/* o	Usage: Styling for FAQ section headers or accordion headers. */}
      {variant === "FAQHeader" && (
        <p
          className={`
          ${className} body-standard font-inter font-semibold`}
        >
          {children}
        </p>
      )}
      {/* o	Usage: Tabs, accordion controls • FAQ Answers */}
      {variant === "FAQAnswer" && (
        <p
          className={`
          ${className} body-standard font-inter`}
        >
          {children}
        </p>
      )}

      {/* o	Usage: Small interactive buttons, links within text */}
      {variant === "ActionLink" && (
        <p
          className={`
          ${className} link-cta font-inter normal-case`}
          onClick={onClick}
        >
          {children}
        </p>
      )}
    </>
  );
};

export default InteractiveText;
